<template>
    <div class="loader">
        <div v-if="dataMode && !dataHideOnEmpty">
            <slot name="dataTitle"></slot>
            <template v-if="data != null">
                <slot v-if="data.length > 0 || loadingFlag === false">
                </slot>
                <slot name="no-data" v-else>
                    <p class="alert alert-warning"  role="alert">No se encontraron.</p>
                </slot>
            </template>
            <slot name="loading" v-else>
                <svg-item :size="size" :icon="icon" :color="color"></svg-item>
            </slot>
        </div>
        <div v-if="flagMode && flag">
            <slot name="loading">
                <svg-item :size="size" :icon="icon" :color="color" :customAttribute="customAttribute"></svg-item>
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'loader',
    mounted () {
        this.language = this.$getLang();
        // this.search();
    },
    props: {
        data: {
            type: Object,
            default: null
        },
        flag: {
            type: Boolean,
            default: null
        },
        dataHideOnEmpty: {
            type: Boolean,
            default: true
        },
        flagMode: {
            type: Boolean,
            default: true
        },
        dataMode: {
            type: Boolean,
            default: false
        },
        size: {
            type: Number,
            default: 22
        },
        color: {
            type: String
        },
        backgroundColor: {
            type: String
        },
        icon: {
            type: String,
            default: 'spinner'
        },
        customAttribute: {
            type: Object
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/elements/Loader.vue